import { Box, createTheme, Typography } from "@mui/material";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import Actions from "./carlton/action";
import ModuleCategorys from "./carlton/module-categories";
import ModulePermissions from "./carlton/module-permissions";
import Projects from "./carlton/project";
import ProjectModules from "./carlton/project-modules";
import ProjectPermissions from "./carlton/project-permissions";
import Roles from "./carlton/role";
import Users from "./carlton/user";
import UserRole from "./carlton/user-role";
import Form from "./carlton/user/form";
import Dashboard from "./scenes/dashboard";
import Login from "./scenes/login";
import Topbar from "./scenes/global/Topbar";
import { ColorModeContext, themeSettings, useMode } from "./theme";
import Loading from "./components/Loading";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import Sidebar from "scenes/global/sidebar/Sidebar";
// import Sidebar from "scenes/global/Sidebar"

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loading isLoading={true} />;
  }

  if (!user) {
    return (
      <ThemeProvider theme={createTheme(themeSettings("dark"))}>
        <CssBaseline />
        <Login />
      </ThemeProvider>
    );
  }

  return <AuthenticatedApp />;
}

function AuthenticatedApp() {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <SidebarProvider>
            {/* <Sidebar /> */}
            <Sidebar />
            <main className="content">
              {/* <Topbar /> */}
              <Box
                display="flex"
                justifyContent="space-between"
                flexDirection="column"
                flex={1}
              >
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/create-user" element={<Form />} />
                  <Route path="/projects" element={<Projects />} />
                  <Route path="/roles" element={<Roles />} />
                  <Route path="/actions" element={<Actions />} />
                  <Route
                    path="/module-categories"
                    element={<ModuleCategorys />}
                  />
                  <Route path="/project-modules" element={<ProjectModules />} />
                  <Route path="/user-role-assignment" element={<UserRole />} />
                  <Route
                    path="/project-permissions"
                    element={<ProjectPermissions />}
                  />
                  <Route
                    path="/module-permissions"
                    element={<ModulePermissions />}
                  />
                </Routes>
                <Box
                  sx={{
                    marginTop: "auto",
                    padding: "15px",
                    borderTop: "1px solid var(--color-primary-200)",
                  }}
                >
                  <Typography variant="subtitle2">
                    Carlton Flights © Copyright 2026 All rights reserved.
                  </Typography>
                </Box>
              </Box>
            </main>
          </SidebarProvider>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
